import { styled } from '@mui/material';

export const FieldLabel = styled('label')(({ theme: { palette: { primary } } }) => {
  return { color: primary.light, marginBottom: '8px', fontSize: '14px' };
});
